import { render, staticRenderFns } from "./OracleLocation.vue?vue&type=template&id=47b61798&"
import script from "./OracleLocation.vue?vue&type=script&lang=js&"
export * from "./OracleLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports